<script lang="ts">
  import { nvrs, streams, selectedNvr, sidebarCollapsed } from '../lib/stores';
  import NvrItem from './NvrItem.svelte';
  import type { NvrInfo } from '../lib/types';

  type Props = {
    onaddnvr?: () => void;
    onnvrmenu?: (nvr: NvrInfo, anchor: HTMLElement) => void;
  };
  let { onaddnvr, onnvrmenu }: Props = $props();

  function toggle(): void {
    sidebarCollapsed.update((v) => !v);
    document.body.classList.toggle('sidebar-collapsed', $sidebarCollapsed);
  }

  // Keep body class in sync on mount + when store changes.
  $effect(() => {
    document.body.classList.toggle('sidebar-collapsed', $sidebarCollapsed);
  });
</script>

<aside class="sidebar">
  <div class="brand">
    <div class="logo">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M23 7l-7 5 7 5V7z" />
        <rect x="1" y="5" width="15" height="14" rx="2" />
      </svg>
    </div>
    <span class="label">sarmatcam</span>
  </div>
  <button class="toggle" onclick={toggle} aria-label="toggle sidebar">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  </button>
  <div class="list">
    <NvrItem
      isAll
      allCount={$streams.length}
      active={$selectedNvr === ''}
      onclick={() => {
        $selectedNvr = '';
        document.body.classList.remove('sidebar-open');
      }}
    />
    {#each $nvrs as n (n.id)}
      <NvrItem
        nvr={n}
        active={$selectedNvr === n.id}
        onclick={() => {
          $selectedNvr = n.id;
          document.body.classList.remove('sidebar-open');
        }}
        onmenuclick={(anchor) => onnvrmenu?.(n, anchor)}
      />
    {/each}
  </div>
  <button class="add" onclick={onaddnvr}>
    <span class="icon">+</span>
    <span class="name">Добавить рег</span>
  </button>
</aside>

<style>
  .sidebar {
    grid-area: sidebar;
    background: var(--bg-elev);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border-right: 1px solid var(--border);
    display: flex; flex-direction: column;
    overflow: hidden; z-index: 20;
  }
  .brand {
    display: flex; align-items: center; gap: 10px;
    padding: 0 16px; height: var(--header-h);
    flex-shrink: 0;
  }
  .logo {
    width: 24px; height: 24px; flex-shrink: 0;
    border-radius: 6px;
    background: linear-gradient(135deg, var(--accent), #5e5ce6);
    display: grid; place-items: center;
  }
  .logo :global(svg) { width: 14px; height: 14px; color: #fff; }
  .label { font-weight: 600; letter-spacing: -.01em; white-space: nowrap; }
  :global(body.sidebar-collapsed) .label { opacity: 0; pointer-events: none; }

  .toggle {
    position: absolute; top: 12px; left: var(--sidebar-w-expanded);
    transform: translateX(-50%);
    width: 24px; height: 24px;
    display: grid; place-items: center;
    border-radius: 50%;
    background: var(--bg-elev);
    border: 1px solid var(--border);
    transition: left .25s cubic-bezier(.2,.8,.2,1);
    z-index: 30;
  }
  :global(body.sidebar-collapsed) .toggle { left: var(--sidebar-w-collapsed); }
  .toggle :global(svg) { width: 12px; height: 12px; color: var(--fg-muted); transition: transform .25s; }
  :global(body.sidebar-collapsed) .toggle :global(svg) { transform: rotate(180deg); }

  .list { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 6px; }

  .add {
    margin: 6px; padding: 8px 10px;
    border: 1px dashed var(--border); border-radius: var(--radius-sm);
    color: var(--fg-muted);
    display: flex; align-items: center; gap: 10px;
    transition: border-color .15s, color .15s;
  }
  .add:hover { border-color: var(--accent); color: var(--accent); }
  .icon { width: 20px; height: 20px; flex-shrink: 0; display: grid; place-items: center; font-size: 16px; }
  :global(body.sidebar-collapsed) .add .name { opacity: 0; pointer-events: none; }

  @media (max-width: 700px) {
    .sidebar {
      position: fixed; left: 0; top: 0; bottom: 0;
      width: var(--sidebar-w-expanded);
      transform: translateX(-100%);
      transition: transform .25s;
    }
    :global(body.sidebar-open) .sidebar { transform: translateX(0); }
    .toggle { display: none; }
  }
</style>
